<template>
  <div
    class="multiple-profile-default"
    :class="{ xs: size === 'xs', sm: size === 'sm', md: size === 'md', lg: size === 'lg' }"
  >
    <h-e-profile-default
      v-for="(profile, index) in formatedProfiles"
      :key="index"
      :first-name="profile.firstName"
      :last-name="profile.lastName"
      :size="size"
      :style="'left : ' + index * 19 + 'px'"
      style="position: absolute; top: 0"
    >
    </h-e-profile-default>
    <i
      v-if="add || profiles.length > showNumberFormated"
      class="mdi mdi-plus-circle-outline mdi-18px cursor-pointer"
      style="position: absolute; top: 2px"
      :style="'left : ' + showNumberFormated * 19 + 'px'"
    ></i>
  </div>
</template>

<script>
import { FunctionHelpers } from '@/node-sdk'

export default {
  name: 'multiple-profile-default',

  props: {
    users: {
      type: Array,
      required: true,
    },
    assignedUsers: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    add: {
      type: Boolean,
      default: false,
    },
    showNumber: {
      type: Number,
      default: 3,
    },
    team: {
      type: Boolean,
      default: false,
    },
    entityName: String,
  },

  data() {
    return {
      formatedProfiles: [],
      showNumberFormated: this.showNumber,
      profiles: [],
    }
  },

  watch: {
    assignedUsers: {
      deep: true,
      handler() {
        this.formatUsers()
        this.$emit('change')
      },
    },
  },

  mounted() {
    this.formatUsers()
  },

  methods: {
    formatUsers() {
      this.profiles = []
      this.formatedProfiles = []
      if (!this.team) {
        this.profiles = FunctionHelpers.formatUsers(this.users, this.assignedUsers)
      } else {
        this.profiles = FunctionHelpers.formatTeams(this.assignedUsers, this.entityName)
      }
      this.setupShowNuber()
      this.splitProfiles()
    },

    splitProfiles() {
      this.formatedProfiles = this.profiles.slice(0, this.showNumberFormated)
    },

    setupShowNuber() {
      this.showNumberFormated = this.showNumber
      if (this.showNumberFormated > this.profiles.length) {
        this.showNumberFormated = this.profiles.length
      }
    },
  },
}
</script>

<style scoped></style>
